// extracted by mini-css-extract-plugin
export default {"modal":"SignUp_modal__tOZ7D","title":"SignUp_title__ETEba"};